import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLoading: false,
  isError: false,
  error: null,
  hasData: false,
  data: null,
  lastQuery: null,
  isDownloadLoading: false,
  downloadError: null,
  downloadBlobUrl: null,
  downloadFileName: null,
  downloadMimeType: null
};
const governmentReportsSlice = createSlice({
  name: "governmentReports",
  initialState,
  reducers: {
    governmentReportsRequest: (state, action) => {
      state.isLoading = true;
      state.isError = false;
      state.error = null;
      state.lastQuery = action.payload;
    },
    governmentReportsSuccess: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.error = null;
      state.hasData = true;
      state.data = action.payload;
    },
    governmentReportsFailure: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.hasData = false;
      state.error = typeof action.payload === "string" ? action.payload : "Something went wrong while fetching reports.";
    },
    resetGovernmentReports: state => {
      state.isLoading = false;
      state.isError = false;
      state.error = null;
      state.hasData = false;
      state.data = null;
    },
    governmentReportsDownloadRequest: (state, _action) => {
      state.isDownloadLoading = true;
      state.downloadError = null;
      state.downloadBlobUrl = null;
      state.downloadFileName = null;
      state.downloadMimeType = null;
    },
    governmentReportsDownloadSuccess: (state, action) => {
      state.isDownloadLoading = false;
      state.downloadError = null;
      state.downloadBlobUrl = action.payload.blobUrl;
      state.downloadFileName = action.payload.fileName ?? null;
      state.downloadMimeType = action.payload.mimeType ?? null;
    },
    governmentReportsDownloadFailure: (state, action) => {
      state.isDownloadLoading = false;
      state.downloadError = typeof action.payload === "string" ? action.payload : "Failed to download reports.";
      state.downloadBlobUrl = null;
      state.downloadFileName = null;
      state.downloadMimeType = null;
    },
    resetGovernmentReportsDownload: state => {
      state.isDownloadLoading = false;
      state.downloadError = null;
      state.downloadBlobUrl = null;
      state.downloadFileName = null;
      state.downloadMimeType = null;
    }
  }
});
export const {
  governmentReportsRequest,
  governmentReportsSuccess,
  governmentReportsFailure,
  resetGovernmentReports,
  governmentReportsDownloadRequest,
  governmentReportsDownloadSuccess,
  governmentReportsDownloadFailure,
  resetGovernmentReportsDownload
} = governmentReportsSlice.actions;
export default governmentReportsSlice.reducer;